/**
 * Mock backend endpoint sabitleri.
 *
 * Path'ler relative — `src/lib/http` instance'ı `baseURL=${PUBLIC_URL}/api`
 * (dev) veya `import.meta.env.VITE_API_URL` (prod) ile birlikte kullanır.
 *
 * Component'ler bu modülü doğrudan import etmemeli; feature başına
 * `features/<x>/api/repository.js` üstünden çağrılır.
 */
export const TaskApi = "task.json";
export const TodoApi = "todo.json";
export const AllProjectApi = "allProject.json";
